import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeLocal360 } from '../../actions';
export default function Local360Overlay() {
    const dispatch = useDispatch();
    const { isOpen, videoId } = useSelector((state) => state['features/local-360'] || {});
    if (!isOpen || !videoId) {
        return null;
    }
    // Use the videoId as the URL, or fallback to the specified URL
    const iframeUrl = videoId.startsWith('http')
        ? videoId
        : `https://live.durlabhdarshan.com/aframe/index.html`;
    return (React.createElement("div", { style: {
            position: 'absolute',
            inset: 0,
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(0,0,0,0.6)'
        } },
        React.createElement("div", { style: { position: 'relative', width: '80%', height: '80%', background: 'black', borderRadius: 8 } },
            React.createElement("button", { onClick: () => dispatch(closeLocal360()), style: {
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    zIndex: 1001,
                    background: 'rgba(0,0,0,0.5)',
                    color: 'white',
                    border: 'none',
                    borderRadius: 4,
                    padding: '6px 10px',
                    cursor: 'pointer'
                } }, "Close"),
            React.createElement("iframe", { src: iframeUrl, width: "100%", height: "100%", frameBorder: "0", allowFullScreen: true, style: {
                    border: 'none',
                    borderRadius: 8
                }, title: "360 Live View" }))));
}
